import { api, getAllPages } from "./client";
import type { Device } from "@/types/device";

interface ResponseID {
  id: string;
}

export const getDevices = () => getAllPages<Device>("/v1/devices");

export const getDevice = (id: string) =>
  api.get<Device>(`/v1/devices/${id}`);

// NOTE: Deactivation has no UI yet; these complete the devices endpoints so a
// "deactivate device" action has an API to call when it lands.

export const deactivateDevice = (id: string) =>
  api.delete<ResponseID>(`/v1/devices/${id}`);

export const deactivateDevicesByUser = (userId: string) =>
  api.delete<ResponseID[]>("/v1/devices", {
    params: { user_id: userId },
  });
